import { createDefaultLoadable, createDefaultILoadableArray, ILoadableArray, ILoadableWrapper, Loadable } from '../../models/loadable';
import { IFinding, IZone } from '../../models/detection.interface';
import { ICharts, IFindingsPage, IJobResults, ISpotlyteJob, ISpotlyteJobDetail, ISpotlyteQnaTurn, ISpotlyteSource, ISummary } from '../../models/spotlyte.interface';

export interface IResultBlobs {
    loading: boolean;
    error: boolean;
    summary: ISummary | null;
    charts: ICharts | null;
    zones: IZone[];
}

export const initialResultBlobs: IResultBlobs = {
    loading: false,
    error: false,
    summary: null,
    charts: null,
    zones: [],
};

export interface IExportState {
    loading: boolean;
    error: boolean;
}

export const initialExportState: IExportState = {
    loading: false,
    error: false,
};

export interface ISpotlyteState {
    sources: ILoadableArray<ISpotlyteSource>;
    jobs: ILoadableArray<ISpotlyteJob>;
    selectedJob: ILoadableWrapper<ISpotlyteJobDetail> | null;
    jobResults: ILoadableWrapper<IJobResults> | null;
    resultBlobs: IResultBlobs;
    findings: ILoadableWrapper<IFindingsPage> | null;
    findingsData: ILoadableArray<IFinding>;
    qnaHistory: ILoadableArray<ISpotlyteQnaTurn>;
    qnaAsk: Loadable;
    csvExport: IExportState;
    pdfExport: IExportState;
}

export const initialSpotlyteState: ISpotlyteState = {
    sources: createDefaultILoadableArray(),
    jobs: createDefaultILoadableArray(),
    selectedJob: null,
    jobResults: null,
    resultBlobs: initialResultBlobs,
    findings: null,
    findingsData: createDefaultILoadableArray() as ILoadableArray<IFinding>,
    qnaHistory: createDefaultILoadableArray(),
    qnaAsk: createDefaultLoadable(),
    csvExport: initialExportState,
    pdfExport: initialExportState,
};
